import type { LucideIcon } from "lucide-react";
import { Spinner } from "./Spinner";

/** Quick-action tile in the home Actions panel (spec §2, item 2). */
export function ActionTile({
  icon: Icon,
  title,
  subtitle,
  tint,
  bg,
  pending = false,
  onPress
}: {
  icon: LucideIcon;
  title: string;
  subtitle: string;
  /** CSS color for the icon. */
  tint: string;
  /** Tile background color. */
  bg: string;
  pending?: boolean;
  onPress: () => void;
}) {
  return (
    <button type="button" className="action-tile" style={{ background: bg }} disabled={pending} onClick={onPress}>
      {pending ? (
        <span className="action-tile-spinner">
          <Spinner size={16} />
        </span>
      ) : null}
      <Icon size={28} strokeWidth={2.75} style={{ color: tint }} />
      <span className="action-tile-title">{title}</span>
      <span className="action-tile-subtitle">{subtitle}</span>
    </button>
  );
}
